module.exports = __webpack_public_path__ + "img/deviceicon.49763138.png";